export default __webpack_public_path__ + "static/PCI-e1410a820111155a62828156917a81f3.svg";